/**
 * 挂载分享弹窗和挑战横幅，并注册 window.ShareKit.open。
 * 复制到其他项目时调用这个函数，传入该站的 ShareSite。
 */
import { createApp, type App } from 'vue'
import ShareHost from './ShareHost.vue'
import type { SharePayload, ShareSite, ShareTrackEvent } from './types.ts'

export interface MountShareKitOptions {
  site: ShareSite
  /** 页脚或导航上 [data-share-site] 使用的载荷 */
  sitePayload?: SharePayload
  /** 根据当前地址决定要不要显示挑战横幅。返回空字符串表示不显示。 */
  resolveChallenge?: (location: Location) => string | null
  onTrack?: (event: ShareTrackEvent) => void
}

export function mountShareKit(options: MountShareKitOptions): App<Element> {
  const el = document.createElement('div')
  document.body.appendChild(el)
  let opener: ((payload: SharePayload) => void) | null = null
  const app = createApp(ShareHost, {
    site: options.site,
    sitePayload: options.sitePayload,
    resolveChallenge: options.resolveChallenge,
    onTrack: (event: ShareTrackEvent) => options.onTrack?.(event),
  })
  const proxy = app.mount(el) as unknown as { open: (payload: SharePayload) => void }
  opener = (payload) => proxy.open(payload)
  window.ShareKit = {
    open(payload: SharePayload) {
      opener?.(payload)
    },
  }
  return app
}
